import { put, select } from 'redux-saga/effects';

import * as StatsActions from '../../actions';
import * as D from '../../deps';
import * as TTMSelectors from '../../selectors';
import * as StatsUtils from '../../utils';

import * as StatsWorkers from './index';

export function* handleStop({ data }) {
  const timeStop = data.CURRENT_TIMESTAMP || D.Utils.Time.getNow();
  const ttmEvents = yield select(TTMSelectors.selectTTMEvents);
  const events = ttmEvents.map(event => {
    return StatsUtils.createTimeToMusicStatsObject(
      timeStop - event.timeStart,
      event.ttmAction,
      event.audioType,
    );
  });
  yield StatsWorkers.logTimeToMusicEvents(events);
  yield put(StatsActions.timeToMusicClear());
}

export function* handleSkipCancel({ data }) {
  yield put(StatsActions.ttmTrackSkippedCancel());
  yield put(StatsActions.ttmTrackThumbsDownCancel());
}
